import apiClient from '@/services/axios'

export async function put(eodReport) {
  var response = await apiClient.put('/EodReports/', eodReport)
  if (response) {
    return response.data
  }

  throw new Error('Unable to update eod report')
}